import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cx from "classnames";
import Script from "next/script";
import { useEffect, useRef } from "react";
export var TrustpilotWidgetTemplates;
(function(TrustpilotWidgetTemplates) {
    TrustpilotWidgetTemplates["carousel"] = "54ad5defc6454f065c28af8b";
    TrustpilotWidgetTemplates["strip"] = "5613c9cde69ddc09340c6beb";
    TrustpilotWidgetTemplates["starter"] = "5613c9cde69ddc09340c6beb";
    TrustpilotWidgetTemplates["microTrustScore"] = "5419b637fa0340045cd0c936";
    TrustpilotWidgetTemplates["grid"] = "539adbd6dec7e10e686debee";
    TrustpilotWidgetTemplates["microStar"] = "5419b732fbfb950b10de65e5";
    TrustpilotWidgetTemplates["microCombo"] = "5419b6ffb0d04a076446a9af";
})(TrustpilotWidgetTemplates || (TrustpilotWidgetTemplates = {}));
export var TrustpilotWidget = function(param) {
    var _widget = param.widget, widget = _widget === void 0 ? TrustpilotWidgetTemplates.carousel : _widget, className = param.className, _height = param.height, height = _height === void 0 ? "240px" : _height;
    var ref = useRef(null);
    useEffect(function() {
        if (window.Trustpilot && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Script, {
                src: "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: ref,
                className: cx("trustpilot-widget", className),
                "data-locale": "en-GB",
                "data-template-id": widget,
                "data-businessunit-id": "5d513cfbed9f5f00012db9a5",
                "data-style-height": height,
                "data-style-width": "100%",
                "data-theme": "light",
                "data-stars": "4,5",
                "data-review-languages": "en",
                "data-testid": "trust-pilot",
                children: /*#__PURE__*/ _jsx("a", {
                    href: "https://uk.trustpilot.com/review/cinch.co.uk",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: "Trustpilot"
                })
            })
        ]
    });
};
export default TrustpilotWidget;
